import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { useHistory  } from "react-router-dom";

const AppointmentCancelConfirmation = ({ classes }) => {

  let navigate = useHistory ();
  function handleClick() {
    navigate.push("/patients");
  }
  return (
    <div className={classes.container}>
      <Grid container spacing={8} className={classes.containerForm}>

        <Grid item xs={12}>
          <h2 className={classes.headerText}>You're appointment has been cancelled.</h2>

          <p className={classes.subtext}>
            You will also receive an email confirmation.
          </p>

          <p className={classes.subtext}>
            <Button
              onClick={handleClick}
              className={classes.button}
            >
              Go to dashboard
            </Button>
            </p>
        </Grid>
      </Grid>
    </div>
  );
};

const styles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
  },

  button: {
    backgroundColor: '#0277bd',
    color: 'white',
    '&:visited': {
      color: 'white',
    },
  },
  containerForm: {
    width: '50%',
    padding: '1rem',
    paddingTop: '90px',
    '@media only screen and (max-width: 1024px)': {
      width: '100%',
    },
  },
  headerText: {
    color: '#1C1C1C',
    fontSize: '40px',
    fontWeight: '300',
    lineHeight: '47px',
    paddingBottom: '25px',
  },
  subtext: {
    color: '#1C1C1C',
    fontSize: '16px',
    lineHeight: '24px',
    paddingBottom: '25px',
  },
});

export default withStyles(styles)(AppointmentCancelConfirmation);
